import {ActionReducerMap} from "@ngrx/store";
import {
  ISystemParameterGroupState,
  systemParameterGroupReducer,
} from "../../pages/management/system-parameter-management/store/system-parameter-group.reducer";
import {menuGroupReducer, MenuGroupState} from "../../pages/management/menu-management/store/menu-group.reducer";
import {MenuGroupEffects} from "../../pages/management/menu-management/store/menu-groups.effects";
import {
  SystemParameterGroupEffects
} from "../../pages/management/system-parameter-management/store/system-parameter-group.effects";
import {
  ISystemParameterState,
  systemParameterReducer
} from "../../pages/management/system-parameter-management/store/system-parameter.reducer";

export interface AppState {
  systemParameterGroupReducer: ISystemParameterGroupState,
  systemParameterReducer: ISystemParameterState,
  menuGroup: MenuGroupState
}


export const appReducer: ActionReducerMap<AppState> = {
  systemParameterGroupReducer: systemParameterGroupReducer,
  systemParameterReducer: systemParameterReducer,
  menuGroup: menuGroupReducer
}

export const appEffects = [SystemParameterGroupEffects, MenuGroupEffects];
